# Define service to interact w/ RESTful end-point for the customer's DirectDebitAuthorization
angular.module("avant.services").service "DirectDebitService", ["$http", "$rootScope", "$q", 'ApplicationService',
 ($http, $rootScope, $q, ApplicationService) ->

  c =

    debit_card_submit: (data) ->
      deferred = $q.defer()
      request = $http.post("/payment_details/create_debit_card", angular.extend({customer_application_id: ApplicationService.target_application_id()}, data))

      request.success (response) ->
        deferred.resolve response

      request.error (response) ->
        deferred.reject response

      deferred.promise

    ddi_submit: (data) ->
      deferred = $q.defer()
      request = $http.put("/customer/direct_debit_authorization", angular.extend({customer_application_id: ApplicationService.target_application_id()}, data))

      request.success (response) ->
        deferred.resolve response

      request.error (response) ->
        deferred.reject response

      deferred.promise
  c
]
